export { default } from './UnscoredTableItem'
